import { DIRECTORIES_REQUEST, DIRECTORIES_CONAGO_FETCH, DIRECTORIES_ACTORS_FETCH, DIRECTORIES_ACTORS_GROUPS_FETCH,DIRECTORIES_FAIL } from "../store/config";

const directoriesInit = {
	isFetching: false,
	conago: [],
	actors: [],
	actors_groups: [],
	error: null,
	timestamp: null
};

const directories = (state=directoriesInit,action) => {
	switch (action.type) {
		case DIRECTORIES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case DIRECTORIES_CONAGO_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				conago: action.payload,
				timestamp: action.timestamp
			}
		case DIRECTORIES_ACTORS_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				actors: action.payload,
				timestamp: action.timestamp
			}
		case DIRECTORIES_ACTORS_GROUPS_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				actors_groups: action.payload,
				timestamp: action.timestamp
			}
		case DIRECTORIES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
};

export default directories;


// WEBPACK FOOTER //
// ./src/reducers/directories.jsx